export const DEFAULT_INSTRUCTOR_REVIEW_PAGE_SIZE = 3;
export const DEFAULT_INSTRUCTOR_REVIEW_PAGE_OFFSET = 0;